import { render } from "./ConfigForm.vue?vue&type=template&id=2dd7df9a&scoped=true"
import script from "./ConfigForm.vue?vue&type=script&lang=js"
export * from "./ConfigForm.vue?vue&type=script&lang=js"

import "./ConfigForm.vue?vue&type=style&index=0&id=2dd7df9a&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd7df9a"]])

export default __exports__